import { NeededFromEq } from '@pages/Products/components/OnBoardingModal/OnBoardingModal.utils';
import { KnownData } from './knownData';

export function mutateKnownData(state: KnownData, equipment: NeededFromEq) {
  const { product, manufacturerImg, user, tags, equipmentStatus } = equipment;
  if (product.id) {
    state.knownProducts[product.id] = {
      manufacturerImg,
      imageUrl: product.imageUrl ?? null,
      model: product.model ?? null,
      id: product.id,
      manufacturerName: equipment.manufacturerName ?? null,
    };
  }
  if (user && user.id) {
    state.knownUsers[user.id] = { id: user.id, name: user.name };
  }
  tags.forEach(tag => {
    state.knownTags[tag.id] = tag;
  });

  if (equipmentStatus) {
    state.knownStatuses[equipmentStatus.id] = equipmentStatus;
  }
  return state;
}
